export default __webpack_public_path__ + "static/media/fail.3273f503.png";